import React, { useState, useEffect } from 'react'
import axios from './axios';
import "./Row.css"
import YouTube from 'react-youtube';
import movieTrailer from 'movie-trailer'

const IMG_BASE_URL = "https://image.tmdb.org/t/p/w500/";

function Row( {title, fetchUrl, isLargeRow}) {
const [movies, setMovies] = useState([]);
const [trailerUrl, setTrailerUrl] = useState("");

useEffect(() => {
    async function fetchData() {
        const request = await axios.get(fetchUrl);
        setMovies(request.data.results)
        return request;
    }
    fetchData();
}, [fetchUrl]);

const opts = {
height: '390',
width: '640',
playerVars: {
    // https://developers.google.com/youtube/player_parameters
    autoplay: 1,
},
};

const handleClick = async (movie) => {
console.log(movie)
if(trailerUrl) {
    setTrailerUrl("");
} else {
     /*movieTrailer(null, {tmdbId : movie.id})
        .then((url) =>{
            console.log(url)
            const urlParams = new URLSearchParams(new URL(url).search);
            setTrailerUrl(urlParams.get("v"))
        })
        .catch((error) => console.log(error)); */
        let trailerurl = await axios.get(
            `/movie/${movie.id}/videos?api_key=fb34530271b349314af0de263d16ab5a`
          );
          setTrailerUrl(trailerurl.data.results[0]?.key);
}
}

return (
    <div className="row"> 
        <h2>{title}</h2>
        <div className='row_posters'>
            {/* {row posters} */}
            {movies.map(movie => (
                <img 
                key={movie.id}
                onClick={() => handleClick(movie)}
                className={`row_poster ${isLargeRow && "row__posterLarge"}`}
                src={`${IMG_BASE_URL}${isLargeRow ? movie.poster_path : movie.backdrop_path}`} alt={movie.name}/>
            ))}
        </div>
        {trailerUrl && <YouTube videoId={trailerUrl} opts={opts}/>}
    </div>
)
}

export default Row
